// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");

function anyInProgress(attachments) {
  return attachments.some(Attachments.Attachment.isInProgress);
}

function validateAttachments(attachments) {
  var anyFailed = attachments.some(Attachments.Attachment.isFailed);
  var anyInProgress = attachments.some(Attachments.Attachment.isInProgress);
  if (anyFailed) {
    return {
            TAG: "Error",
            _0: "Upload failed."
          };
  } else if (anyInProgress) {
    return {
            TAG: "Error",
            _0: "Upload still in progress..."
          };
  } else {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
}

exports.anyInProgress = anyInProgress;
exports.validateAttachments = validateAttachments;
/* Attachments Not a pure module */
